import React, { useContext } from "react";

import ElementContext from "../../../components/ElementContext";

import { Headline } from "../../../components/Headline";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./departmentAddress.module.less";

function DepartmentAddress({
    country,
    name,
    subtitle,
    number,
    place,
    street,
    zip
}) {
    const { isLightBg } = useContext(ElementContext);

    const countryUpperCase =
        typeof country === "string" && country ? country.toUpperCase() : "";
    return (
        <>
            <Headline semanticOfHeadline="h5">{name}</Headline>
            <div className={gcs(styles.contactDepartmentAddressBlock)}>
                {
                    <>
                        <Headline semanticOfHeadline="H5 Style">{name}</Headline>
                        <div
                            className={gcs(
                                styles.contactDepartmentAddressBlock,
                                !isLightBg ? styles.lightColor : ""
                            )}
                        >
                            <span>{subtitle}</span>
                            <span>
                                {street} {number}
                            </span>
                            <span>
                                {zip} {place}
                            </span>
                            <span>{countryUpperCase}</span>
                        </div>
                    </>
                }
            </div>
        </>
    );
}

export { DepartmentAddress };
